module.exports = __webpack_public_path__ + "images/wheel-icon-d8ffdc73d180e19ff68f6a81326c87ca.png";